import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "return-trip"
};
const _hoisted_2 = {
  class: "main-wrap return-trip-wrap"
};
const _hoisted_3 = {
  id: "positionMap"
};
const _hoisted_4 = {
  key: 1,
  class: "van-list"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  key: 1,
  class: "order-card-cell-button disable"
};
const _hoisted_7 = {
  class: "order-info"
};
const _hoisted_8 = {
  class: "order-info-item"
};
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", {
  class: "icon"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "dot start-dot"
})], -1);
const _hoisted_10 = {
  class: "text"
};
const _hoisted_11 = {
  style: {
    "margin-left": "5px"
  }
};
const _hoisted_12 = {
  style: {
    "margin-left": "5px"
  }
};
const _hoisted_13 = {
  class: "order-info-item"
};
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", {
  class: "icon"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "dot end-dot"
})], -1);
const _hoisted_15 = {
  class: "text"
};
const _hoisted_16 = {
  style: {
    "margin-left": "5px"
  }
};
const _hoisted_17 = {
  class: "order-info-item"
};
const _hoisted_18 = {
  class: "return-trip-bottom-wrap"
};
const _hoisted_19 = {
  class: "van-list"
};
const _hoisted_20 = {
  class: "card order-card"
};
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", {
  id: "map"
}, null, -1);
const _hoisted_22 = {
  key: 0,
  class: "card order-card"
};
const _hoisted_23 = {
  key: 0,
  class: "order-card-cell-tag wait"
};
const _hoisted_24 = {
  key: 1,
  class: "order-card-cell-tag pending"
};
const _hoisted_25 = {
  key: 2,
  class: "order-card-cell-tag progressing"
};
const _hoisted_26 = {
  key: 3,
  class: "order-card-cell-tag pending"
};
const _hoisted_27 = {
  key: 4,
  class: "order-card-cell-tag payment"
};
const _hoisted_28 = {
  class: "order-info"
};
const _hoisted_29 = {
  class: "order-info-item order-time"
};
const _hoisted_30 = {
  class: "icon"
};
const _hoisted_31 = {
  class: "text"
};
const _hoisted_32 = /*#__PURE__*/_createElementVNode("strong", null, "到点出发", -1);
const _hoisted_33 = {
  style: {
    "margin-left": "5px"
  }
};
const _hoisted_34 = {
  class: "order-info-item"
};
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", {
  class: "icon"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "dot start-dot"
})], -1);
const _hoisted_36 = {
  class: "text"
};
const _hoisted_37 = {
  style: {
    "margin-left": "5px"
  }
};
const _hoisted_38 = {
  class: "order-info-item"
};
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", {
  class: "icon"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "dot end-dot"
})], -1);
const _hoisted_40 = {
  class: "text"
};
const _hoisted_41 = {
  style: {
    "margin-left": "5px"
  }
};
const _hoisted_42 = {
  style: {
    "margin-left": "5px"
  }
};
const _hoisted_43 = {
  class: "order-info-item"
};
const _hoisted_44 = {
  class: "icon"
};
const _hoisted_45 = {
  class: "text"
};
const _hoisted_46 = {
  style: {
    "margin-left": "5px"
  }
};
const _hoisted_47 = {
  key: 1,
  class: "card order-card"
};
const _hoisted_48 = {
  class: "order-info"
};
const _hoisted_49 = {
  class: "order-info-item"
};
const _hoisted_50 = {
  class: "icon"
};
const _hoisted_51 = {
  class: "text"
};
const _hoisted_52 = {
  style: {
    "margin-left": "5px"
  }
};
const _hoisted_53 = {
  key: 0,
  class: "order-info-item"
};
const _hoisted_54 = {
  class: "icon"
};
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, " 金牌司机 ", -1);
const _hoisted_56 = {
  key: 0,
  class: "return-trip-bottom-wrap"
};
const _hoisted_57 = {
  key: 1,
  class: "return-trip-bottom-wrap"
};
const _hoisted_58 = {
  key: 1,
  class: "van-list"
};
const _hoisted_59 = {
  key: 0,
  class: "order-card-cell-tag wait"
};
const _hoisted_60 = {
  key: 1,
  class: "order-card-cell-tag pending"
};
const _hoisted_61 = {
  key: 2,
  class: "order-card-cell-tag progressing"
};
const _hoisted_62 = {
  key: 3,
  class: "order-card-cell-tag payment"
};
const _hoisted_63 = {
  key: 4,
  class: "order-card-cell-tag pending"
};
const _hoisted_64 = {
  key: 5,
  class: "order-card-cell-tag wait"
};
const _hoisted_65 = {
  key: 6,
  class: "order-card-cell-tag cancel"
};
const _hoisted_66 = {
  class: "order-info"
};
const _hoisted_67 = {
  class: "order-info-item"
};
const _hoisted_68 = /*#__PURE__*/_createElementVNode("div", {
  class: "icon"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "dot start-dot"
})], -1);
const _hoisted_69 = {
  class: "text"
};
const _hoisted_70 = {
  style: {
    "margin-right": "5px"
  }
};
const _hoisted_71 = {
  class: "order-info-item"
};
const _hoisted_72 = /*#__PURE__*/_createElementVNode("div", {
  class: "icon"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "dot end-dot"
})], -1);
const _hoisted_73 = {
  class: "text"
};
const _hoisted_74 = {
  style: {
    "margin-right": "5px"
  }
};
const _hoisted_75 = {
  class: "order-info-item"
};
const _hoisted_76 = {
  class: "return-trip-bottom-wrap"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_nav_bar = _resolveComponent("nav-bar");
  const _component_van_empty = _resolveComponent("van-empty");
  const _component_van_cell = _resolveComponent("van-cell");
  const _component_van_tag = _resolveComponent("van-tag");
  const _component_van_button = _resolveComponent("van-button");
  const _component_van_tab = _resolveComponent("van-tab");
  const _component_van_icon = _resolveComponent("van-icon");
  const _component_van_tabs = _resolveComponent("van-tabs");
  const _component_return_trip_passenger_form = _resolveComponent("return-trip-passenger-form");
  const _component_van_popup = _resolveComponent("van-popup");
  const _component_van_date_picker = _resolveComponent("van-date-picker");
  const _component_van_time_picker = _resolveComponent("van-time-picker");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_nav_bar, {
    class: "return-trip-nav-bar",
    title: $setup.title,
    border: false
  }, null, 8, ["title"]), _createVNode(_component_van_tabs, {
    color: "#ffb54d",
    active: $setup.tabActive,
    "onUpdate:active": _cache[1] || (_cache[1] = $event => $setup.tabActive = $event),
    onClickTab: $options.tabClick,
    onChange: $options.tabChange,
    swipeable: ""
  }, {
    default: _withCtx(() => [_withDirectives(_createElementVNode("div", _hoisted_3, null, 512), [[_vShow, false]]), _createVNode(_component_van_tab, {
      title: "回城车大厅"
    }, {
      default: _withCtx(() => [!$setup.orders || $setup.orders.length === 0 ? (_openBlock(), _createBlock(_component_van_empty, {
        key: 0,
        description: "暂无回城车行程"
      })) : _createCommentVNode("", true), $setup.orders && $setup.orders.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.orders, (order, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass('card order-card ' + (order.order_type === 'RETURN_TRIP_ORDER_TYPE_ON_TIME' ? 'on-time' : 'on-people'))
        }, [_createVNode(_component_van_cell, null, {
          value: _withCtx(() => [!$setup.status ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "order-card-cell-button",
            onClick: $event => $options.joinOrder(order)
          }, "我要同行", 8, _hoisted_5)) : (_openBlock(), _createElementBlock("div", _hoisted_6, "我要同行"))]),
          title: _withCtx(() => [_createTextVNode(_toDisplayString($options.CommonUtil.formatDay(order.departure_time, "MM月DD日")) + " 出发 ", 1)]),
          _: 2
        }, 1024), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_hoisted_9, _createElementVNode("div", _hoisted_10, [_createElementVNode("strong", null, _toDisplayString($options.GetDistance([order.departure_address_longitude, order.departure_address_latitude])), 1), _createElementVNode("small", _hoisted_11, _toDisplayString(order.departure_address_city), 1), _createElementVNode("small", _hoisted_12, _toDisplayString(order.departure_address_description), 1)])]), _createElementVNode("div", _hoisted_13, [_hoisted_14, _createElementVNode("div", _hoisted_15, [_createElementVNode("strong", null, _toDisplayString(order.destination_address_city), 1), _createElementVNode("small", _hoisted_16, _toDisplayString(order.destination_address_description), 1)])]), _createElementVNode("div", _hoisted_17, [order.estimated_cost ? (_openBlock(), _createBlock(_component_van_tag, {
          key: 0,
          type: "danger",
          plain: "",
          style: {
            "margin-right": "8px"
          }
        }, {
          default: _withCtx(() => [_createElementVNode("small", null, "预估 ￥" + _toDisplayString(order.estimated_cost), 1)]),
          _: 2
        }, 1024)) : _createCommentVNode("", true), _createVNode(_component_van_tag, {
          type: "primary",
          plain: ""
        }, {
          default: _withCtx(() => [_createElementVNode("small", null, "可坐 " + _toDisplayString(order.seats_count) + " 人", 1)]),
          _: 2
        }, 1024)])])], 2);
      }), 128))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_18, [_createVNode(_component_van_button, {
        class: "return-trip-publish-button",
        type: "success",
        block: "",
        onClick: $options.returnTripPublish
      }, {
        default: _withCtx(() => [_createTextVNode(" 发布回城车 ")]),
        _: 1
      }, 8, ["onClick"])])]),
      _: 1
    }), _createVNode(_component_van_tab, {
      title: "我的回城车"
    }, {
      default: _withCtx(() => {
        var _$setup$status;
        return [_withDirectives(_createVNode(_component_van_empty, {
          description: "暂无正在进行的行程数据"
        }, null, 512), [[_vShow, !$setup.status]]), _withDirectives(_createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createVNode(_component_van_cell, {
          title: "行程地图"
        }, {
          value: _withCtx(() => [_createElementVNode("div", {
            class: "order-card-cell-button default",
            onClick: _cache[0] || (_cache[0] = $event => $options.getStatus(false, true, true))
          }, "刷新状态 ")]),
          _: 1
        }), _hoisted_21]), $setup.status ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_createVNode(_component_van_cell, {
          title: "行程状态"
        }, {
          value: _withCtx(() => [$setup.status.order_status === 'RETURN_TRIP_ORDER_STATUS_WAITING' ? (_openBlock(), _createElementBlock("div", _hoisted_23, " 预定中 ")) : _createCommentVNode("", true), $setup.status.order_status === 'RETURN_TRIP_ORDER_STATUS_PENDING' ? (_openBlock(), _createElementBlock("div", _hoisted_24, "候车中 ")) : _createCommentVNode("", true), $setup.status.order_status === 'RETURN_TRIP_ORDER_STATUS_PROGRESSING' ? (_openBlock(), _createElementBlock("div", _hoisted_25, "行程中 ")) : _createCommentVNode("", true), $setup.status.order_status === 'RETURN_TRIP_ORDER_STATUS_ARRIVED_DROP_OFF' ? (_openBlock(), _createElementBlock("div", _hoisted_26, "已到达 ")) : _createCommentVNode("", true), $setup.status.order_status === 'RETURN_TRIP_ORDER_STATUS_WAIT_PAYMENT' ? (_openBlock(), _createElementBlock("div", _hoisted_27, "待付款 ")) : _createCommentVNode("", true)]),
          _: 1
        }), _createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_createVNode(_component_van_icon, {
          name: "underway",
          size: "13px",
          color: "#1989fa"
        })]), _createElementVNode("div", _hoisted_31, [_hoisted_32, _createElementVNode("small", _hoisted_33, _toDisplayString($options.CommonUtil.formatDay($setup.status.departure_time, "MM月DD日 HH:mm")), 1)])]), _createElementVNode("div", _hoisted_34, [_hoisted_35, _createElementVNode("div", _hoisted_36, [_createElementVNode("strong", null, _toDisplayString($setup.status.departure_address_city), 1), _createElementVNode("small", _hoisted_37, _toDisplayString($setup.status.departure_address_description), 1)])]), _createElementVNode("div", _hoisted_38, [_hoisted_39, _createElementVNode("div", _hoisted_40, [_createElementVNode("strong", null, _toDisplayString($options.GetDistance([$setup.status.destination_address_longitude, $setup.status.destination_address_latitude])), 1), _createElementVNode("small", _hoisted_41, _toDisplayString($setup.status.destination_address_city), 1), _createElementVNode("small", _hoisted_42, _toDisplayString($setup.status.destination_address_description), 1)])]), _createElementVNode("div", _hoisted_43, [_createElementVNode("div", _hoisted_44, [_createVNode(_component_van_icon, {
          name: "gold-coin",
          size: "13px",
          color: "#FF0080"
        })]), _createElementVNode("div", _hoisted_45, [_createElementVNode("strong", null, "￥" + _toDisplayString($setup.status.estimated_cost), 1), _createElementVNode("small", _hoisted_46, _toDisplayString($setup.status.seats_count) + "人坐车 ", 1)])])])])) : _createCommentVNode("", true), (_$setup$status = $setup.status) !== null && _$setup$status !== void 0 && _$setup$status.driver_info ? (_openBlock(), _createElementBlock("div", _hoisted_47, [_createVNode(_component_van_cell, {
          title: "司机信息",
          value: "联系司机",
          "is-link": ""
        }), _createElementVNode("div", _hoisted_48, [_createElementVNode("div", _hoisted_49, [_createElementVNode("div", _hoisted_50, [_createVNode(_component_van_icon, {
          name: "manager",
          color: "#0055ff"
        })]), _createElementVNode("div", _hoisted_51, [_createElementVNode("strong", null, _toDisplayString($setup.status.driver_info.name), 1), _createElementVNode("small", _hoisted_52, _toDisplayString($setup.status.driver_info.passenger_phone_number), 1)])]), false ? (_openBlock(), _createElementBlock("div", _hoisted_53, [_createElementVNode("div", _hoisted_54, [_createVNode(_component_van_icon, {
          name: "award",
          size: "16px",
          color: "#0055ff"
        })]), _hoisted_55])) : _createCommentVNode("", true)])])) : _createCommentVNode("", true)], 512), [[_vShow, $setup.status]]), !$setup.status ? (_openBlock(), _createElementBlock("div", _hoisted_56, [_createVNode(_component_van_button, {
          class: "return-trip-publish-button",
          type: "success",
          block: "",
          onClick: $options.returnTripPublish
        }, {
          default: _withCtx(() => [_createTextVNode(" 发布回城车 ")]),
          _: 1
        }, 8, ["onClick"])])) : _createCommentVNode("", true), $setup.status ? (_openBlock(), _createElementBlock("div", _hoisted_57, [$setup.status.order_status !== 'RETURN_TRIP_ORDER_STATUS_WAIT_PAYMENT' ? (_openBlock(), _createBlock(_component_van_button, {
          key: 0,
          loading: $setup.submitLoading,
          class: "return-trip-publish-button",
          type: "success",
          block: "",
          onClick: $options.returnTripCancel
        }, {
          default: _withCtx(() => [$setup.status.self ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_createTextVNode(" 关闭行程 ")], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_createTextVNode(" 退出行程 ")], 64))]),
          _: 1
        }, 8, ["loading", "onClick"])) : _createCommentVNode("", true), $setup.status.order_status === 'RETURN_TRIP_ORDER_STATUS_WAIT_PAYMENT' ? (_openBlock(), _createBlock(_component_van_button, {
          key: 1,
          loading: $setup.submitLoading,
          class: "return-trip-publish-button",
          type: "success",
          block: "",
          onClick: $options.returnTripPayment
        }, {
          default: _withCtx(() => [_createTextVNode(" 支付费用 ")]),
          _: 1
        }, 8, ["loading", "onClick"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)];
      }),
      _: 1
    }), _createVNode(_component_van_tab, {
      title: "历史回城车"
    }, {
      default: _withCtx(() => [!$setup.historyOrders || $setup.historyOrders.length === 0 ? (_openBlock(), _createBlock(_component_van_empty, {
        key: 0,
        description: "暂无历史回城车行程"
      })) : _createCommentVNode("", true), $setup.historyOrders && $setup.historyOrders.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_58, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.historyOrders, (order, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass('card order-card ' + (order.order_type === 'RETURN_TRIP_ORDER_TYPE_ON_TIME' ? 'on-time' : 'on-people'))
        }, [_createVNode(_component_van_cell, null, {
          value: _withCtx(() => [order.order_status === 'RETURN_TRIP_ORDER_STATUS_WAITING' ? (_openBlock(), _createElementBlock("div", _hoisted_59, " 预定中 ")) : _createCommentVNode("", true), order.order_status === 'RETURN_TRIP_ORDER_STATUS_PENDING' ? (_openBlock(), _createElementBlock("div", _hoisted_60, "候车中 ")) : _createCommentVNode("", true), order.order_status === 'RETURN_TRIP_ORDER_STATUS_PROGRESSING' ? (_openBlock(), _createElementBlock("div", _hoisted_61, "行程中 ")) : _createCommentVNode("", true), order.order_status === 'RETURN_TRIP_ORDER_STATUS_WAIT_PAYMENT' ? (_openBlock(), _createElementBlock("div", _hoisted_62, "待付款 ")) : _createCommentVNode("", true), order.order_status === 'RETURN_TRIP_ORDER_STATUS_RATING' ? (_openBlock(), _createElementBlock("div", _hoisted_63, "待评价 ")) : _createCommentVNode("", true), order.order_status === 'RETURN_TRIP_ORDER_STATUS_COMPLETED' ? (_openBlock(), _createElementBlock("div", _hoisted_64, "已完成 ")) : _createCommentVNode("", true), order.order_status === 'RETURN_TRIP_ORDER_STATUS_CANCEL' ? (_openBlock(), _createElementBlock("div", _hoisted_65, "已关闭 ")) : _createCommentVNode("", true)]),
          title: _withCtx(() => [_createTextVNode(_toDisplayString($options.CommonUtil.formatDay(order.departure_time, "MM月DD日")) + " 出发 ", 1)]),
          _: 2
        }, 1024), _createElementVNode("div", _hoisted_66, [_createElementVNode("div", _hoisted_67, [_hoisted_68, _createElementVNode("div", _hoisted_69, [_createElementVNode("strong", _hoisted_70, _toDisplayString(order.departure_address_city), 1), _createElementVNode("small", null, _toDisplayString(order.departure_address_description), 1)])]), _createElementVNode("div", _hoisted_71, [_hoisted_72, _createElementVNode("div", _hoisted_73, [_createElementVNode("strong", _hoisted_74, _toDisplayString(order.destination_address_city), 1), _createElementVNode("small", null, _toDisplayString(order.destination_address_description), 1)])]), _createElementVNode("div", _hoisted_75, [order.estimated_cost ? (_openBlock(), _createBlock(_component_van_tag, {
          key: 0,
          type: "danger",
          plain: "",
          style: {
            "margin-right": "8px"
          }
        }, {
          default: _withCtx(() => [_createElementVNode("small", null, "预估 ￥" + _toDisplayString(order.estimated_cost), 1)]),
          _: 2
        }, 1024)) : _createCommentVNode("", true), _createVNode(_component_van_tag, {
          type: "primary",
          plain: ""
        }, {
          default: _withCtx(() => [_createElementVNode("small", null, _toDisplayString(order.seats_count) + "人坐车", 1)]),
          _: 2
        }, 1024)])])], 2);
      }), 128))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_76, [_createVNode(_component_van_button, {
        class: "return-trip-publish-button",
        type: "success",
        block: "",
        onClick: $options.returnTripPublish
      }, {
        default: _withCtx(() => [_createTextVNode(" 发布回城车 ")]),
        _: 1
      }, 8, ["onClick"])])]),
      _: 1
    })]),
    _: 1
  }, 8, ["active", "onClickTab", "onChange"])]), _createVNode(_component_van_popup, {
    show: $setup.showReturnTripPassengerForm,
    "onUpdate:show": _cache[2] || (_cache[2] = $event => $setup.showReturnTripPassengerForm = $event),
    closeable: "",
    position: "bottom"
  }, {
    default: _withCtx(() => [_createVNode(_component_return_trip_passenger_form, {
      ref: "returnTripPassengerForm",
      "user-data": $setup.userData,
      adcode: $setup.cityCode,
      "start-province": $setup.startProvince,
      "start-city": $setup.startCity,
      "start-district": $setup.startDistrict,
      "start-address": $setup.startAddress,
      "start-position": $setup.startPosition,
      "end-position": $setup.endPosition,
      "show-departure-time-date-picker-click": $options.showDepartureTimeDatePickerClick,
      "return-trip-passenger-form-success": $options.returnTripPassengerFormSuccess
    }, null, 8, ["user-data", "adcode", "start-province", "start-city", "start-district", "start-address", "start-position", "end-position", "show-departure-time-date-picker-click", "return-trip-passenger-form-success"])]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_popup, {
    show: $setup.showDepartureTimeDatePicker,
    "onUpdate:show": _cache[5] || (_cache[5] = $event => $setup.showDepartureTimeDatePicker = $event),
    position: "bottom"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_date_picker, {
      modelValue: $setup.departure_time_date,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $setup.departure_time_date = $event),
      title: "选择日期",
      "min-date": new Date(),
      onConfirm: $options.confirmDepartureTimeDatePicker,
      onCancel: _cache[4] || (_cache[4] = $event => $setup.showDepartureTimeDatePicker = false)
    }, null, 8, ["modelValue", "min-date", "onConfirm"])]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_popup, {
    show: $setup.showDepartureTimeHourMinPicker,
    "onUpdate:show": _cache[8] || (_cache[8] = $event => $setup.showDepartureTimeHourMinPicker = $event),
    position: "bottom"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_time_picker, {
      modelValue: $setup.departure_time_hour_min,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $setup.departure_time_hour_min = $event),
      title: "选择时间",
      "min-date": new Date(),
      onConfirm: $options.confirmDepartureTimeHourMinPicker,
      onCancel: _cache[7] || (_cache[7] = $event => $setup.showDepartureTimeHourMinPicker = false)
    }, null, 8, ["modelValue", "min-date", "onConfirm"])]),
    _: 1
  }, 8, ["show"])]);
}